import { Alert, Badge, Button, Group, Text } from '@mantine/core';
import { IconWifi, IconWifiOff, IconRefresh } from '@tabler/icons-react';
import type { OfflineState } from './types';

interface OfflineIndicatorProps extends OfflineState {
  onSync?: () => void;
}

export function OfflineIndicator({
  isOnline,
  pendingCount,
  isSyncing,
  onSync,
}: OfflineIndicatorProps) {
  if (isOnline && pendingCount === 0) return null;

  const isOffline = !isOnline;

  return (
    <Alert
      color={isOffline ? 'red' : 'yellow'}
      icon={isOffline ? <IconWifiOff size={18} /> : <IconWifi size={18} />}
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        borderRadius: 0,
      }}
      styles={{
        root: { paddingTop: 8, paddingBottom: 8 },
      }}
    >
      <Group justify="space-between" wrap="nowrap">
        <Group gap="xs" wrap="nowrap">
          <Text size="sm" fw={500}>
            {isOffline
              ? "You're offline. Changes will sync when reconnected."
              : isSyncing
                ? 'Syncing pending changes...'
                : 'Back online. Pending changes ready to sync.'}
          </Text>
          {pendingCount > 0 && (
            <Badge size="sm" variant="filled" color={isOffline ? 'red' : 'yellow'}>
              {pendingCount} pending
            </Badge>
          )}
        </Group>
        {isOnline && pendingCount > 0 && !isSyncing && onSync && (
          <Button
            size="xs"
            variant="light"
            leftSection={<IconRefresh size={14} />}
            onClick={onSync}
          >
            Sync Now
          </Button>
        )}
      </Group>
    </Alert>
  );
}
